import { Component, Inject } from '@angular/core';
import { ModalController } from '@ionic/angular';
import Env from '@ridango/core/env';

@Component({
    selector: 'ridango-ticket-activate-same-validity-confirmation-modal',
    templateUrl: './ticket-activate-same-validity-confirmation.component.html',
    styleUrls: ['./ticket-activate-same-validity-confirmation-modal.component.scss']
})
export class TicketActivateSameValidityConfirmationComponent {
    constructor(
        private modalCtrl: ModalController,
        @Inject('ENV') public env: Env
    ) {}

    confirmActivation() {
        this.modalCtrl.dismiss(true, 'confirm');
    }

    cancel() {
        this.modalCtrl.dismiss(false, 'cancel');
    }
}
